import { Environment } from 'src/shared/interfaces/environment';

export const environment: Environment = {
  name: 'preproduction',
  version: '2.2.0',
  production: false,
  debug: true,
  api: '/api',

  keycloak: {
    realm: 'hygie31-qal',
    url: 'https://qal.auth.pfa-pharma.hygie31group.com',
    clientId: 'pfa',
  },
};
